import {Component, OnInit} from '@angular/core';
import {TicketsService} from '../../services/tickets.service';
import {Ticket, TicketSearchParams} from '../../model/Ticket';
import {FaqCategoryService} from '../../services/faq-category.service';
import {FaqCategory} from '../../model/FaqCategory';
import {Information} from '../../model/information';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';

import {BreadcrumbComponent} from "../../components/common/breadcrumb/breadcrumb.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {MobileSearchComponent} from "../../components/common/mobile-search/mobile-search.component";
import {ToggleComponent} from "../../components/common/toggle/toggle.component";
import {NgbNav, NgbNavItem, NgbNavLink, NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {StatePipe} from "../../components/common/StatePipe";
import {MinPipe} from "../../components/common/MinPipe";
import {SortPipe} from "../../components/common/SortPipe";
import {StateDisplayPipe} from "../../components/common/StateDisplayPipe";
import {BadgeComponent} from "../../components/common/badge/badge.component";
import {VersionStripPipe} from "../../components/common/VersionStripPipe";
import {TicketReadInfoComponent} from "./ticket-read-info/ticket-read-info.component";
import {CdtInfosComponent} from "../../components/user/cdt-infos/cdt-infos.component";
import {FormsModule} from "@angular/forms";
import {VersionIntegrationStripPipe} from "../../components/common/VersionIntegrationStripPipe";
import { SpinnerComponent } from 'src/app/components/common/spinner/spinner.component';
import { DynamicTableComponent } from 'src/app/components/common/dynamic-table/dynamic-table.component';

@Component({
    selector: 'app-tickets',
    imports: [
    BreadcrumbComponent,
    FaIconComponent,
    MobileSearchComponent,
    ToggleComponent,
    NgbNav,
    NgbNavItem,
    StatePipe,
    MinPipe,
    SortPipe,
    RouterLink,
    NgbTooltip,
    StateDisplayPipe,
    BadgeComponent,
    VersionStripPipe,
    SpinnerComponent,
    TicketReadInfoComponent,
    CdtInfosComponent,
    FormsModule,
    VersionIntegrationStripPipe,
    NgbNavLink,
    DynamicTableComponent
],
    templateUrl: './tickets.component.html',
    styleUrls: ['./tickets.component.css']
})
export class TicketsComponent implements OnInit {

  tableHeaders = [
    {
      label: 'N° ticket',
      sortable: true,
      property: 'number'
    },
    {
      label: 'Titre',
      sortable: true,
      property: 'title',
    },
    {
      label: 'État',
      sortable: true,
      property: 'state'
    },
    {
      label: 'File',
      sortable: true,
      property: 'queue',
    },
    {
      label: 'Produit',
      sortable: true,
      property: 'product'
    },
    {
      label: 'Version',
      sortable: true,
      property: 'version',
      class: 'd-none d-lg-table-cell'
    },
    {
      label: 'Intégration',
      sortable: true,
      property: 'versionIntegration',
      class: 'd-none d-lg-table-cell'
    },
    {
      label: 'Âge',
      sortable: true,
      property: 'created',
      sortIcon: 'numeric'
    }
  ]

  tickets: Ticket[];

  error = false;
  categories: FaqCategory[];
  infos: Information[];

  company = false;
  checkInfos = false;
  showCdt = false;
  ticketsReady = false;
  versionsReady = false;
  searchByContent;

  search: TicketSearchParams = new TicketSearchParams();

  constructor(private ticketService: TicketsService,
              private faqCategoryService: FaqCategoryService,
              private route: ActivatedRoute,
              private router: Router) {
  }

  ngOnInit(): void {
    this.loadParams();
    this.faqCategoryService.getAllCategories().subscribe(cats => {
      this.categories = cats;
    });
    this.fetchTickets();
  }

  fetchTickets(): void {
    this.setParams();
    this.ticketService.getTickets(this.company, this.search.search).subscribe(lt => {
      this.tickets = lt;
      this.ticketsReady = true;
    });
    this.ticketService.getPossibleVersions().subscribe(() => {
      this.versionsReady = true;
    });
  }

  loadParams(): void {
    this.company = this.route.snapshot.queryParams.company === 'true';
    this.search.page = this.route.snapshot.queryParams.page ? +this.route.snapshot.queryParams.page : 1;
    // Tri par défaut : plus récent en premier (desc) — retour au comportement d'avant la 1.4
    this.search.asc = this.route.snapshot.queryParams.asc !== undefined
      ? this.route.snapshot.queryParams.asc !== 'false'
      : false;
    this.search.sort = this.route.snapshot.queryParams.sort ? this.route.snapshot.queryParams.sort : 'created';
    this.search.state = this.route.snapshot.queryParams.state ? this.route.snapshot.queryParams.state : 'open';
    this.search.search = this.route.snapshot.queryParams.search ? this.route.snapshot.queryParams.search : '';
    this.searchByContent = this.search.search ? this.search.search : undefined;
  }

  setParams(): void {
    this.router.navigate([], {
      queryParams: {
        page: this.search.page,
        asc: this.search.asc,
        sort: this.search.sort,
        state: this.search.state,
        search: this.search.search,
        company: this.company
      }
    });
  }

  changeState(state: string): void {
    if (this.search.state !== state) {
      this.search.page = 1;
      this.search.state = state;
      this.setParams();
    }
  }

  previousPage(): void {
    if (this.search.page > 1) {
      this.search.page--;
      this.setParams();
    }
  }

  nextPage(count: number): void {
    if (this.search.page < (count / this.search.pagesize)) {
      this.search.page++;
      this.setParams();
    }
  }

  changeCompany(): void {
    this.search.page = 1;
    this.fetchTickets();
  }

  changeSearch(event): void {
    this.ticketsReady = false;
    this.search.page = 1;
    this.searchByContent = this.search.search;
    this.fetchTickets();
    this.setParams();
    event.preventDefault();
    event.stopPropagation();
  }

  searchMobile(event): void {
    this.ticketsReady = false;
    this.search.search = event;
    this.search.page = 1;
    this.searchByContent = this.search.search;
    this.fetchTickets();
  }

  removeSearch(): void {
    this.ticketsReady = false;
    this.search.page = 1;
    this.searchByContent = undefined;
    this.search.search = '';
    this.fetchTickets();
  }

  getCategoryFromSlug(slug: string): FaqCategory {
    return slug ? this.categories.find(c => {
      return c.slug.toLowerCase() === slug.toLowerCase();
    }) : null;
  }

  duration(t0: any): any {
    const d =  (new Date()).getTime() - (new Date(t0)).getTime();
    const time = {};
    time['j'] = Math.floor(d / 1000 / 60 / 60 / 24);
    time['h'] = Math.floor(d / 1000 / 60 / 60 - time['j'] * 24);
    time['m'] = Math.floor(d / 1000 / 60 - time['j'] * 24 * 60 - time['h'] * 60);
    time['s'] = Math.floor(d / 1000 - time['j'] * 24 * 60 * 60 - time['h'] * 60 * 60 - time['m'] * 60);
    const t = [];
    Object.keys(time).forEach(key => {
      if ((time[key] > 0 || t.length > 0) && t.length < 2) {
        t.push(time[key] + ' ' + key);
      }
    });
    return t.join(' ');
  }

  updateSort(fieldname: string): void {
    if (this.search.sort === fieldname) {
      this.search.asc = !this.search.asc;
    } else {
      this.search.asc = true;
      this.search.sort = fieldname;
    }
    this.setParams();
  }
}
